<template lang="pug">
.wrap
  page-title Add new permission group

  el-form(ref="groupForm" label-position="top" :rules="groupRules" :model="newGroup")
    el-form-item(label="Group name" prop="name")
      el-input(v-model.trim="newGroup.name")

    el-form-item(label="Has app access" prop="hasAppAccess")
      el-switch(on-text="" off-text="" v-model="newGroup.hasAppAccess")

  el-table(:data="appPermissions" empty-text="No entries" v-loading='loading')
    el-table-column(label="Permission")
      template(slot-scope="scope")
        div {{ scope.row.label }}

    el-table-column(label="View" align='center')
      template(slot-scope="scope")
        el-checkbox(v-model='groupPermissions[scope.$index].canView')

    el-table-column(label="Add" align='center')
      template(slot-scope="scope")
        el-checkbox(v-model='groupPermissions[scope.$index].canAdd'
        :indeterminate='checkDisabledPermission(groupPermissions[scope.$index], "canAdd")'
        :disabled='checkDisabledPermission(groupPermissions[scope.$index], "canAdd")')

    el-table-column(label="Edit" align='center')
      template(slot-scope="scope")
        el-checkbox(v-model='groupPermissions[scope.$index].canEdit'
        :indeterminate='checkDisabledPermission(groupPermissions[scope.$index], "canEdit")'
        :disabled='checkDisabledPermission(groupPermissions[scope.$index], "canEdit")')

  .actions
    el-button(type='primary' @click="submitForm" :loading='loading') Save

</template>

<script>
import { mapActions } from "vuex";
import PageTitle from "@/shared/components/layout/PageTitle";
import CrudMixin from "@/shared/mixins/Crud";

export default {
  mixins: [CrudMixin],
  components: { PageTitle },
  data() {
    return {
      appPermissions: [],
      groupPermissions: [],
      loading: false,
      groupRules: {
        name: [{ required: true, message: "Required field", trigger: "blur" }]
      },
      newGroup: {
        name: "",
        hasAppAccess: true
      }
    };
  },
  computed: {
    appId() {
      return this.$route.query.appId;
    },
    appLicenseId() {
      return this.$route.query.appLicenseId;
    }
  },
  methods: {
    ...mapActions({
      fetchPermissions: "permissions/fetchPermissions",
      createGroup: "groups/createGroup"
    }),
    fetchData() {
      this.fetchPermissions({ params: { app: this.appId } }).then(data => {
        this.appPermissions = data;
        this.groupPermissions = this.appPermissions.map(perm => ({
          permission: perm,
          canView: true,
          canEdit: false,
          canAdd: false
        }));
      });
    },
    submitForm() {
      this.$refs.groupForm.validate(valid => {
        if (!valid) {
          this.$notify({
            title: "Error",
            message: "Please fix the validation errors",
            type: "error"
          });
          return;
        }
        const groupData = {
          ...this.newGroup,
          appLicenseId: this.appLicenseId,
          permissions: this.groupPermissions.map(gp => ({
            ...gp,
            permission: gp.permission.id
          }))
        };

        this.wrapApiAction(this.createGroup)({ data: groupData }).then(data => {
          this.$router.push({
            name: "companyAdmin:groupUpdate",
            params: { groupId: data.id }
          });
        });
      });
    },
    checkDisabledPermission(groupPermission, type) {
      return (
        ["recognise", "flags"].indexOf(groupPermission.permission.codename) >=
          0 && ["canAdd", "canEdit"].indexOf(type) >= 0
      );
    }
  },
  created() {
    this.fetchData();
  }
};
</script>

<style scoped lang="scss">
.actions {
  margin-top: 20px;
}
</style>
